


import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'

import { ButtonConfirmed } from '../../Button'
import Row, { AutoRow } from '../../Row'
import Loader from '../../Loader'
import AuditBtn from './AuditBtn'
import OfferMadeBtn from './OfferMadeBtn'
import CancelBtn from './CancelBtn'
import RevokeBtn from './RevokeBtn'
import AuctionBtn from './AuctionBtn'
import SellBtn from './SellBtn'
import BuyBtn from './BuyBtn'

import useYam from '../../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../../hooks'
import { stopPropagation } from '../../../utils/func'
import { useWalletModalToggle } from '../../../state/application/hooks'
import { userTokenAddress } from '../../../userType/userTokenAddress'
import useAllowanceAll from '../../../hooks/nft/useAllowanceAll'
import useApproveAllERC721 from '../../../hooks/nft/useApproveAllERC721'
import useAllowanceERC20 from '../../../hooks/nft/useAllowanceERC20'
import useApproveBid from '../../../hooks/nft/useApproveBid'
import useTokenBalance from '../../../hooks/bakery/useTokenBalance'
import { getBalanceNumber } from '../../../utils/bakery/formatBalance'
import { userTokenDecimals } from '../../../userType/userTokenDecimals'

const Button = styled(ButtonConfirmed)<{bg?: string, color?: string}>`
  border: none;
  font-size: 14px;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  padding: 0;
  background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
  color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  &:hover{
    background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
    color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  }
`
const BtnRow = styled(Row)`
  justify-content: space-between;
  button {
    width: 47%;
    flex: 1 1 auto;
  }
`

export default function ArtworkBtn ({
  artwork, status, isMyArtwork,
  ids, myAksIds, marketType,
  symbol
}: {
  artwork: any, status: number, isMyArtwork?: boolean,
  ids: any, myAksIds: any, marketType: string,
  symbol: string
}) {

  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const allowanceSellAll = useAllowanceAll({type: marketType, marketFlag: 'market'})
  const allowanceBuy = useAllowanceERC20(marketType, symbol)

  const connectWallet = useCallback(async (event) => {
    stopPropagation(event)
    toggleWalletModal()
  }, [toggleWalletModal])

  let decimals = userTokenDecimals(symbol)

  // token balance
  const sushi = useYam()
  const tokenAddress = userTokenAddress(sushi, symbol)
  const [tokenBalance, setTokenBalance] = useState(0)
  const bakeryBalance = useTokenBalance(tokenAddress)
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance, decimals)
    setTokenBalance(balance)
  }, [bakeryBalance, decimals])

  // 授权卖
  const [requestedApprovalAllExchange, setRequestedApprovalAllExchange] = useState(false)
  const onApproveSellAll = useApproveAllERC721(marketType, 'market')
  const handleApproveSellAll = useCallback(
    async (event) => {
      stopPropagation(event)
      try {
        setRequestedApprovalAllExchange(true)
        const txHash = await onApproveSellAll()
        if (!txHash) {
          setRequestedApprovalAllExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalAllExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSellAll, setRequestedApprovalAllExchange]
  )

  // 授权买
  const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  const onApproveBid = useApproveBid(marketType, symbol)
  const handleApproveBid = useCallback(async (event) => {
    stopPropagation(event)
    if(artwork.level === 'v3'){
      try {
        setRequestedApprovalBid(true)
        const txHash = await onApproveBid()
        if (!txHash) {
          setRequestedApprovalBid(false)
        }else {
          setTimeout(() => {
            setRequestedApprovalBid(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [onApproveBid, setRequestedApprovalBid])


  const Btn = () => {
    if (!account) {
      return (
        <Button
          onClick={event => connectWallet(event)}>
          Connect Wallet
        </Button>
      )
    }

    if (status === 0) {
      return (
        <BtnRow>
          <AuditBtn artwork={artwork} />
        </BtnRow>
      )
    }

    if (isMyArtwork) {
      // 参与竞价
      if (ids.includes(artwork.tokenId)) {
        return(
          <BtnRow>
            <OfferMadeBtn 
              ids={ids}
              aksIds={myAksIds}
              artwork={artwork}
              isMyArtwork={isMyArtwork}
              marketType={marketType}
              symbol={symbol}
              />
            <CancelBtn 
              artwork={artwork} 
              marketType={marketType}
              symbol={symbol}
            />
          </BtnRow>
        )
      }

      // 在卖
      if (+artwork.price) {
        return (
          <BtnRow>
            {
              artwork.level === 'v3' &&
              <OfferMadeBtn 
                ids={ids}
                aksIds={myAksIds}
                artwork={artwork}
                isMyArtwork={isMyArtwork}
                marketType={marketType}
                symbol={symbol}
              />
            }
            <RevokeBtn artwork={artwork} marketType={marketType} />
          </BtnRow>
        )
      }

      // 允许卖
      if (allowanceSellAll) {
        return (
          <BtnRow>
            <AuctionBtn
              artwork={artwork}
              marketType={marketType}
              symbol={symbol}
            />
            <SellBtn
              artwork={artwork}
              marketType={marketType}
              symbol={symbol}
            />
          </BtnRow>
        )
      }

      // 不允许卖
      if (!allowanceSellAll) {
        return (
          <Button
            onClick={handleApproveSellAll}
            disabled={requestedApprovalAllExchange}
            fontSize={14}
            height={40}
            altDisabledStyle={requestedApprovalAllExchange}
          >
            {requestedApprovalAllExchange ? (
              <AutoRow gap="6px" justify="center">
                Approving <Loader stroke="white" />
              </AutoRow>
            ) : (
              'Approve NFT Marketplace'
            )}
          </Button>
        )
      }

    } else {
      if (!artwork.price) {
        return null
      }
      // 不允许买
      if (!allowanceBuy.toNumber()) {
        return <>
          {
            <Button
              onClick={handleApproveBid}
              disabled={requestedApprovalBid}
              altDisabledStyle={requestedApprovalBid}
              bg={artwork.level ==='v3' ? '' : '#C4C4C4'}
              color={artwork.level ==='v3' ? '' : '#DEDEDE'}
            >
              {
                requestedApprovalBid ? (
                  <AutoRow gap="6px" justify="center">
                    Approving <Loader stroke="white" />
                  </AutoRow>
                ) : 'Approve NFT Marketplace'
              }
            </Button>
          }
        </>
      }
      
      // 允许买
      if (allowanceBuy.toNumber()) {
        return (
          <BtnRow>
            {
              // artwork.level === 'v2' &&
              <OfferMadeBtn 
                ids={ids}
                aksIds={myAksIds}
                artwork={artwork}
                marketType={marketType}
                isMyArtwork={isMyArtwork}
                symbol={symbol}
              />
            }
            {
              !artwork.auctionPrice &&
              <BuyBtn
                tokenBalance={tokenBalance}
                artwork={artwork}
                marketType={marketType}
                isMyArtwork={isMyArtwork}
                symbol={symbol}
                ids={artwork.level === 'v1' ? [] : ids}
              />
            }
          </BtnRow>
        )
      }
    }


    return null
  }
  return <> { Btn() } </>
}